import { NIL as emptyUuid, v4 as uuidv4 } from 'uuid';

export default {
    data: function () {
        return {
            emptyUuid: emptyUuid
        }
    },
    methods: {
        isUuidEmpty: function (uuid) {
            return uuid == emptyUuid;
        },
        isUuidNullOrEmpty: function (uuid) {
            return (uuid == null) || (uuid == emptyUuid);
        },
        newUuid: function () {
            return uuidv4();
        }
    }
}